import React from 'react';
//import Slider from "react-slick";
//import "slick-carousel/slick/slick.css";
//import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom';
import MainLayout from '../components/layout/MainLayout';

/*const slides = [
  {
    id: 1,
    src: "sliderbg.png",
    text: "Welcome to Our Store",
  },
  {
    id: 2,
    src: "sliderbg.png",
    text: "Check Out Our Latest Collection",
  },
  {
    id: 3,
    src: "sliderbg.png",
    text: "Special Discounts Available",
  },
];

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: false,
};*/

const Home = () => {
  return (
    <MainLayout>
      {/* Promotional Banner */}
      <div className="proskins-banner proskins-mb-lg">
        <div className="proskins-banner-background">
         {/* <Slider {...settings}>
            {slides.map((slide) => (
              <div key={slide.id} className="relative"> */}
                <img
                  src="sliderbg.png"
                  alt="Pick which players will get a Skin in this weekend's upcoming events!"
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "12px",
                  }}
                />
                {/* Text Overlay */}
                <div
                  className="absolute bottom-6 left-0 right-0 flex items-center justify-center text-center px-4"
                  style={{
                    color: "white",
                    fontSize: "24px",
                    fontWeight: "bold",
                    textShadow: "2px 2px 8px rgba(0,0,0,0.7)",
                  }}
                />
             {/* </div>
            ))}
        </Slider> */}
        </div>
        <div className="proskins-banner-content">
          <div className="proskins-banner-text">
            <h2 className="proskins-banner-title">
            Pick which players will get a Skin in this<br/><span className="proskins-section-title proskins-card-title">weekend's upcoming events!</span>
            </h2>
          </div>
        </div>
        
        {/* Pagination Dots 
        <div className="proskins-banner-pagination">
          <div className="proskins-pagination-dot proskins-pagination-dot-active"></div>
          <div className="proskins-pagination-dot"></div>
          <div className="proskins-pagination-dot"></div>
        </div>*/}
      </div>

      {/* How It Works Section */}
      <div className="proskins-mb-lg">
        <h3 className="proskins-section-title headingfont">HOW IT WORKS</h3>
        <div className="proskins-how-it-works-content">
            <p className="proskins-mb-md">
              <strong>Purchasing players/betting</strong> Logged-in users can 'purchase' players for upcoming events, which last a weekend, with some golfers playing the entire weekend and others only Thursday and Friday.
            </p>
            
            <p className="proskins-mb-md">
              <strong>Pricing Information</strong> Purchasing a player for that weekend event will be <strong className='proskins-tier-a-title'>$250</strong> for <span className='proskins-tier-a-title'>tier A</span>, <strong className='proskins-tier-b-title'>$200</strong> for <span className='proskins-tier-b-title'>B</span>, <strong className='proskins-tier-c-title'>$150</strong> for <span className='proskins-tier-c-title'>C</span> and <strong className='proskins-tier-d-title'>$100</strong> for <span className='proskins-tier-d-title'>D</span>.
            </p>
            
            <p className="proskins-mb-md">
            <strong>Approx. 156 Golfers</strong> are available to choose, ranked according the Official World Golf Rankings.
            </p>
          </div>
      </div>

      {/* Player Tiers Section */}
      <div>
        <div className="proskins-tiers-grid">
          {/* A Tier */}
          <div className="proskins-tier-card proskins-tier-a">
            <div className="proskins-tier-icon">
              <Link to="/golfers/">
              <img 
                src="/atier.png" 
                alt="A Tier" 
                className="proskins-tier-image"
              />
              </Link>
            </div>
          </div>

          {/* B Tier */}
          <div className="proskins-tier-card proskins-tier-b">
            <div className="proskins-tier-icon">
            <Link to="/golfers/">
              <img 
                src="/btier.png" 
                alt="B Tier" 
                className="proskins-tier-image"
              />
              </Link>
            </div>
          </div>

          {/* C Tier */}
          <div className="proskins-tier-card proskins-tier-c">
            <div className="proskins-tier-icon">
            <Link to="/golfers/">
              <img 
                src="/ctier.png" 
                alt="C Tier" 
                className="proskins-tier-image"
              />
              </Link>
            </div>
          </div>

          {/* D Tier */}
          <div className="proskins-tier-card proskins-tier-d">
            <div className="proskins-tier-icon">
            <Link to="/golfers/">
              <img 
                src="/dtier.png" 
                alt="D Tier" 
                className="proskins-tier-image"
              />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Home;
